import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Card from './Card';
import Button from './Button';
import { cn } from '@/lib/utils';

interface ErrorCardProps {
  title?: string;
  message?: string | null;
  onRetry?: () => void;
  retryLabel?: string;
  standalone?: boolean; // true = renders its own Card wrapper. false = renders inline content.
  className?: string;
}

export default function ErrorCard({
  title = 'Something went wrong',
  message,
  onRetry,
  retryLabel = 'Try Again',
  standalone = false,
  className,
}: ErrorCardProps) {
  const content = (
    <div className={cn('flex flex-col items-center text-center space-y-6', className)}>
      <div className="w-16 h-16 bg-brand-error/10 text-brand-error rounded-full flex items-center justify-center">
        <AlertTriangle size={28} />
      </div>
      <div className="space-y-2">
        <h3 className="text-lg font-black text-brand-text-dark uppercase tracking-tight">
          {title}
        </h3>
        {message && (
          <p className="text-sm font-medium text-brand-text-muted max-w-sm leading-relaxed">
            {message}
          </p>
        )}
      </div>
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="secondary"
          className="!bg-brand-error hover:!bg-brand-error/90"
        >
          {retryLabel}
        </Button>
      )}
    </div>
  );

  if (standalone) {
    return (
      <Card variant="danger" padding="lg">
        {content}
      </Card>
    );
  }

  return content;
}
